import React, { useState } from "react";
import { QueryRenderer, graphql } from "react-relay";
import environment from "./AuthEnv";
import SettingsPage from "./SettingsPage";
import AccountDetails from "./AccountDetails";
import ThemeProvider from "./contexts/ThemeContext";
import Spinner from "./Spinner";

const StripeCustomerQuery = graphql`
    query AccountDetailsContainerQuery {
        stripeCustomer {
            ...AccountDetails_stripe_Customer
        }
    }
`;

function AccountDetailsContainer(props) {
    const user = props.user;
    let settings = props.settings;
    const title = props.title;
    const style = props.style;
    return (
        <QueryRenderer
            environment={environment}
            query={StripeCustomerQuery}
            variables={{}}
            render={({ error, props }) => {
                if (error) {
                    return <div>Error!</div>;
                }
                if (!props) {
                    return (
                        <div>
                            <Spinner isLoading={true} />
                        </div>
                    );
                }
                return (
                    <div>
                        <ThemeProvider>
                            <AccountDetails
                                user={user}
                                settings={settings}
                                stripe_Customer={props.stripeCustomer}
                                title={title}
                                style={style}
                            />
                        </ThemeProvider>
                    </div>
                );
            }}
        />
    );
}

export default AccountDetailsContainer;
